import { useTranslation } from 'react-i18next'
import { useRef } from 'react'
import { Modal, ModalProps } from 'components/layout/Modal/Modal'
import { GroupFormFields } from 'components/forms/GroupForm/types'
import { GroupForm } from 'components/forms/GroupForm/GroupForm'
import { Label } from 'types/Label'
import * as Styled from './GroupModal.styles'

interface GroupModalProps extends Omit<ModalProps, 'children' | 'onClose'> {
  open: boolean
  isEdit?: boolean
  initialValues?: GroupFormFields
  initialLabels?: Label[]
  onClose: () => void
  onSave: (values: GroupFormFields) => void
  isLoading?: boolean
  isError?: boolean
}

const GroupModal = ({
  open,
  isEdit,
  initialValues,
  initialLabels,
  onClose: handleClose,
  onSave: handleSave,
  isLoading,
  isError,
}: GroupModalProps): JSX.Element => {
  const {
    t,
  } = useTranslation()

  const handleCloseModal = () => {
    handleClose()
  }

  const submitRef = useRef<() => void>(() => {})

  return (
    <Styled.Modal open={open} onClose={handleCloseModal}>
      <Modal.Title variant='h3'>{t(`knowledgeBase.${isEdit ? 'edit' : 'new'}Group`)}</Modal.Title>
      <Styled.ModalContent>
        <GroupForm
          isEdit={isEdit}
          initialValues={initialValues}
          initialLabels={initialLabels}
          onSave={handleSave}
          submitRef={submitRef}
        />
      </Styled.ModalContent>
      <Modal.Actions
        isLoading={isLoading}
        isSaveDisabled={isError}
        onCancel={handleCloseModal}
        onSave={() => submitRef.current()}
        confirmLabel={t(`common.${isEdit ? 'edit' : 'create'}`)}
      />
    </Styled.Modal>
  )
}

export { GroupModal }
